<template>
    <v-chart
        :option="barChartData"
        ref="barChart"
        style="
            width: 90%;
            height: 230px;
            margin-bottom: 20px;
            margin-left: auto;
            margin-right: auto;
            margin-top: 0;
        "
    />
</template>
<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
    TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';

use([CanvasRenderer, PieChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent]);

export default {
    components: {
        VChart,
    },
    props: {
        taiwanDepositTotal: {
            type: Number,
            default: 0,
        },
        foreignDepositTotal: {
            type: Number,
            default: 0,
        },
        taiwanLoanTotal: {
            type: Number,
            default: 0,
        },
        foreignLoanTotal: {
            type: Number,
            default: 0,
        },
        cashTotal: {
            type: Number,
            default: 0,
        },
    },
    watch: {
        taiwanDepositTotal(newValue) {
            if (newValue !== null) {
                this.updateCharts();
            }
        },
    },
    data() {
        return {
            // 存借款比較直條圖
            barChartData: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                },
                backgroundColor: 'transparent',
                grid: {
                    top: '40px',
                    bottom: '30px',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    data: ['存款餘額總計', '借款餘額總計'],
                },
                yAxis: {
                    type: 'value',
                },
                series: [],
            },
        };
    },
    mounted() {
        window.addEventListener('resize', this.updateChartSize);
    },
    destroyed() {
        window.removeEventListener('resize', this.updateChartSize);
    },
    methods: {
        updateChartSize() {
            this.$refs.barChart.resize();
        },
        updateBarChart() {
            const newBarChartData = JSON.parse(JSON.stringify(this.barChartData));
            newBarChartData.series = [
                {
                    name: '台幣',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        show: true,
                        formatter: (param) => param.value.toLocaleString('en-US'),
                    },
                    data: [
                        {
                            value: Math.round(this.taiwanDepositTotal),
                            itemStyle: {
                                color: '#019b01',
                            },
                        },
                        {
                            value: Math.round(Math.abs(this.taiwanLoanTotal)),
                            itemStyle: {
                                color: '#ff6d00',
                            },
                        },
                    ],
                },
                {
                    name: '外幣',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        show: true,
                        formatter: (param) => param.value.toLocaleString('en-US'),
                    },
                    data: [
                        {
                            value: Math.round(this.foreignDepositTotal),
                            itemStyle: {
                                color: '#20c120',
                            },
                        },
                        {
                            value: Math.round(Math.abs(this.foreignLoanTotal)),
                            itemStyle: {
                                color: '#ffba00',
                            },
                        },
                    ],
                },
                {
                    name: '零用金',
                    type: 'bar',
                    stack: 'total',
                    label: {
                        show: true,
                        formatter: (param) => param.value.toLocaleString('en-US'),
                    },
                    data: [
                        {
                            value: this.cashTotal,
                            itemStyle: {
                                color: '#80ea80',
                            },
                        },
                    ],
                },
            ];

            // 長條圖重載
            this.$refs.barChart.clear();
            this.barChartData = newBarChartData;
        },
        updateCharts() {
            this.updateBarChart();
        },
    },
};
</script>
<style>
.ccc {
    color: #019b01;
    color: #20c120;
    color: #80ea80;
}
</style>
